<template>
  <div class="page-header-index-wide">
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="总赛事场数" :total="row.total_sai">
          <a-tooltip title="创办的总赛事次数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
          <template slot="footer">本月新增赛事<span>{{row.month_sai}}场</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="总赛事人数" :total="row.total_sai_member">
          <a-tooltip title="参加赛事的总人数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
          <template slot="footer">本月新增赛事人数<span>{{row.month_sai_member}}人</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="俱乐部数量" :total="row.total_club">
          <a-tooltip title="申请的俱乐部总数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
          <template slot="footer">本月新增俱乐部数量<span>{{row.month_club}}个</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="注册运动员数" :total="row.total_yundongyuan">
          <a-tooltip title="申请注册的总运动员数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
          <template slot="footer">本月注册运动员数<span>{{row.month_yundongyuan}}个</span></template>
        </chart-card>
      </a-col>
<!--      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">-->
<!--        <chart-card :loading="loading" title="访问量" :total="'2123827' | NumberFormat">-->
<!--          <a-tooltip title="页面浏览次数PV" slot="action">-->
<!--            <a-icon type="info-circle-o" />-->
<!--          </a-tooltip>-->
<!--          <div>-->
<!--            <mini-area :data="pvChartData" yTitle="PV" />-->
<!--          </div>-->
<!--          <template slot="footer">日访问量<span> {{ 3821 | NumberFormat }}</span></template>-->
<!--        </chart-card>-->
<!--      </a-col>-->
<!--      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">-->
<!--        <chart-card :loading="loading" title="单位数" :total="NumberFormat(3212)">-->
<!--          <a-tooltip title="实际支付的订单数,不含退款关闭的订单" slot="action">-->
<!--            <a-icon type="info-circle-o" />-->
<!--          </a-tooltip>-->
<!--          <div>-->
<!--            <mini-bar  :data="payChartData" yTitle="队伍数" />-->
<!--          </div>-->
<!--          <template slot="footer">队伍数 <span>28127</span></template>-->
<!--        </chart-card>-->
<!--      </a-col>-->
<!--      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">-->
<!--        <chart-card :loading="loading" title="用户数" :total="NumberFormat(54231)">-->
<!--          <a-tooltip title="平台用户总数" slot="action">-->
<!--            <a-icon type="info-circle-o" />-->
<!--          </a-tooltip>-->
<!--          <div>-->
<!--            <mini-area :data="userChartData" yTitle="客户数" />-->
<!--          </div>-->
<!--          <template slot="footer">今日<span> {{  432 | NumberFormat }}</span></template>-->
<!--        </chart-card>-->
<!--      </a-col>-->
    </a-row>

    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="考级中心总数" :total="row.total_examecenter">
          <a-tooltip title="申请的考级中心（点）总数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
          <template slot="footer">本月新增考级中心（点）<span>{{row.month_examecenter}}个</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="总考级数" :total="row.total_kaoji">
          <a-tooltip title="申请的考级总数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
          <template slot="footer">本月新增考级数<span>{{row.month_kaoji}}个</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="培训总数" :total="row.total_huiyi">
          <a-tooltip title="申请会议培训总数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
          <template slot="footer">本月新增会议数<span>{{row.month_huiyi}}个</span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="培训总人数" :total="row.total_huiyi_member">
          <a-tooltip title="参加会议培训的总人数" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
          <template slot="footer">本月新增参加会议人数<span>{{row.month_huiyi_member}}个</span></template>
        </chart-card>
      </a-col>
    </a-row>

    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="年度总金额" :total="row.order_price_year">
          <a-tooltip title="所属人员年度总消费金额" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="年度奖励金额" :total="row.order_reward_year">
          <a-tooltip title="所属人员年度总奖励金额" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="年度订单数量" :total="row.order_count_year">
          <a-tooltip title="所属人员年度总下单数量" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
          </div>
        </chart-card>
      </a-col>
    </a-row>

<!--    <a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">-->
<!--      <div class="salesCard">-->
<!--        <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">-->

<!--          <a-tab-pane loading="true" tab="赛事报名" key="1">-->
<!--            <a-row>-->
<!--              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">-->
<!--                <bar title="报名趋势" :data="orderPriceChartData" yTitle="人数" />-->
<!--              </a-col>-->
<!--              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">-->
<!--                <rank-list title="热门单位" :list="userRankList"/>-->
<!--              </a-col>-->
<!--            </a-row>-->
<!--          </a-tab-pane>-->
<!--          <a-tab-pane loading="true" tab="会议培训" key="2">-->
<!--            <a-row>-->
<!--              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">-->
<!--                <bar title="销售额排行" :data="orderPriceChartData" yTitle="销售额" />-->
<!--              </a-col>-->
<!--              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">-->
<!--                <rank-list title="门店销售" :list="rankList"/>-->
<!--              </a-col>-->
<!--            </a-row>-->
<!--          </a-tab-pane>-->
<!--          <a-tab-pane loading="true" tab="七彩星级" key="3">-->
<!--            <a-row>-->
<!--              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">-->
<!--                <bar title="销售额排行" :data="orderPriceChartData" yTitle="销售额" />-->
<!--              </a-col>-->
<!--              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">-->
<!--                <rank-list title="门店销售" :list="rankList"/>-->
<!--              </a-col>-->
<!--            </a-row>-->
<!--          </a-tab-pane>-->

<!--        </a-tabs>-->
<!--      </div>-->
<!--    </a-card>-->

    <a-row :gutter="12">
      <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24" v-if="cityList.length > 0">
        <a-card :loading="loading" :bordered="false" title="市级明细" :style="{ marginTop: '24px' }">

          <p v-for="(item,i) in cityList" :key="i"><H3 style="display: inline-block;margin-right: 10px">{{item.city}}</H3> <span>裁判员人数:{{item.caipan_count}},教练员人数:{{item.jiaolian_count}},运动员人数:{{item.caipan_count}}</span></p>
        </a-card>
      </a-col>
      <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24" v-if="orderList.length > 0">
        <a-card :loading="loading" :bordered="false" title="合伙人销售信息" :style="{ marginTop: '24px' }">

          <p v-for="(goods,i) in orderList" :key="i">{{goods.name}} <em>手机号:{{goods.phone}},销售金额:{{goods.total}}</em></p>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import { analysisIndexData  } from '@/api/analysis'
  import ChartCard from '@/components/chart/ChartCard'
  import ACol from 'ant-design-vue/es/grid/Col'
  import ATooltip from 'ant-design-vue/es/tooltip/Tooltip'
  import MiniArea from '@/components/chart/MiniArea'
  import MiniBar from '@/components/chart/MiniBar'
  import MiniProgress from '@/components/chart/MiniProgress'
  import RankList from '@/components/chart/RankList'
  import Bar from '@/components/chart/Bar'
  import Trend from '@/components/Trend'



  export default {
    name: 'Analysis',
    components: {
      ATooltip,
      ACol,
      ChartCard,
      MiniArea,
      MiniBar,
      MiniProgress,
      RankList,
      Bar,
      Trend
    },
    data() {
      return {
        rankList:[],
        loading: true,
        sellerCount:{
          total_order_price:0,
          week_percent:0,
          day_percent:0,
          day_av:0,
        },
        pvTotal:0,
        pvToday:0,
        pvChartData:[
          {
            "x":"12-08",
            "PV":384
          },
          {
            "x":"12-09",
            "PV":315
          },
          {
            "x":"12-10",
            "PV":353
          },
          {
            "x":"12-11",
            "PV":346
          },
          {
            "x":"12-12",
            "PV":228
          },
          {
            "x":"12-13",
            "PV":193
          },
          {
            "x":"12-14",
            "PV":242
          },
          {
            "x":"12-15",
            "PV":275
          },
          {
            "x":"12-16",
            "PV":294
          },
          {
            "x":"12-17",
            "PV":309
          }
        ],
        payChartData:[
          {
            "x":"12-08",
            "订单数":36
          },
          {
            "x":"12-09",
            "订单数":29
          },
          {
            "x":"12-10",
            "订单数":40
          },
          {
            "x":"12-11",
            "订单数":25
          },
          {
            "x":"12-12",
            "订单数":18
          },
          {
            "x":"12-13",
            "订单数":8
          },
          {
            "x":"12-14",
            "订单数":18
          },
          {
            "x":"12-15",
            "订单数":31
          },
          {
            "x":"12-16",
            "订单数":34
          },
          {
            "x":"12-17",
            "订单数":25
          }
        ],
        orderCount:0,
        orderPercent:0,
        userChartData:[
          {
            x:'2019-2-1',
            '客户数': 32,
          },
          {
            x:'2019-2-2',
            '客户数': 32,
          },
          {
            x:'2019-2-3',
            '客户数': 54,
          },
          {
            x:'2019-2-4',
            '客户数': 39,
          },
          {
            x:'2019-2-5',
            '客户数': 92,
          },
          {
            x:'2019-2-6',
            '客户数': 37,
          }
        ],
        userCount:0,
        userToday:0,
        userRankList:[
            {
              name:'南宁市五里亭第一小学',
              total: '302'
            },
            {
              name:'河南工业贸易职业学院',
              total: '298'
            },
            {
              name:'贵港市港北区阳光都市幼儿园',
              total: '283'
            },
            {
              name:'乳山市乳山口镇中心学校小学部',
              total: '193'
            },
            {
              name:'乳山市乳山寨中心学校',
              total: '172'
            },
            {
              name:'郑州市郑东新区康平小学',
              total: '140'
            },
            {
              name:'郑州市郑东新区康平小学',
              total: '130'
            }
        ],
        orderPriceChartData:[
          {
            "x":"12-08",
            "人数":2573.1
          },
          {
            "x":"12-09",
            "人数":2359.2
          },
          {
            "x":"12-10",
            "人数":3896.2
          },
          {
            "x":"12-11",
            "人数":1846.5
          },
          {
            "x":"12-12",
            "人数":2058.1
          },
          {
            "x":"12-13",
            "人数":589
          },
          {
            "x":"12-14",
            "人数":2307.9
          },
          {
            "x":"12-15",
            "人数":2735
          },
          {
            "x":"12-16",
            "人数":2574.5
          },
          {
            "x":"12-17",
            "人数":2115.1
          }
        ],
        goodsRankList:[
          {
            name:'2020年中国（南京）少儿啦啦操精英赛',
            total: '212',
            duiwu: '212',
          },
          {
            name:'2020年桂林少儿赛暨挑战赛',
            total: '212',
            duiwu: '212',
          },
          {
            name:'2020-2021年青岛分站赛',
            total: '212',
            duiwu: '212',
          },
          {
            name:'2020-2020年南京市青少年阳光体育节校园啦啦操联赛',
            total: '212',
            duiwu: '212',
          },
          {
            name:'中国（蚌埠）少儿啦啦操精英赛',
            total: '212',
            duiwu: '212',
          },
          {
            name:'2019年全国啦啦操冠军赛（儿童组）',
            total: '212',
            duiwu: '212',
          }
        ],
        shopGoodsRankList:[
          {
            name:'（青岛站）2020年一级裁判员培训班',
            total: '212',
            duiwu: '212',
          },
          {
            name:'2020年（第三期）全国啦啦操七彩星级A级网络培训班',
            total: '212',
            duiwu: '212',
          },
          {
            name:'2020年（甘肃）七彩星级B级网络培训班',
            total: '212',
            duiwu: '212',
          },
          {
            name:'2020年（西藏）七彩星级B级网络培训班',
            total: '212',
            duiwu: '212',
          },
          {
            name:'2020年（湖南）七彩星级B级网络培训班',
            total: '212',
            duiwu: '212',
          },
          {
            name:'2020年（湖南）七彩星级C级网络培训班',
            total: '212',
            duiwu: '212',
          }
        ],
        cityList: [],
        orderList: [],
        row: {}
      }
    },
    created() {
      let that = this
      setTimeout(() => {
        this.loading = !this.loading
      }, 1000);

      analysisIndexData( ).then(res => {
        console.log(res.data)
        // that.sellerCount = res.data.sellerCount;
        // that.pvTotal = res.data.pvTotal;
        // that.pvToday = res.data.pvToday;
        // that.pvChartData = res.data.pvChartData;
        // that.payChartData = res.data.payChartData;
        // that.orderCount = res.data.orderCount;
        // that.userCount = res.data.userCount;
        // that.userToday = res.data.userToday;
        // that.userRankList = res.data.userRankList;
        // that.orderPriceChartData = res.data.orderPriceChartData
        // that.goodsRankList = res.data.goodsRankList
        // that.shopGoodsRankList = res.data.shopGoodsRankList
        // that.userChartData = res.data.userChartData

        that.row = res.data
        that.cityList=res.data.city_list
        that.orderList=res.data.order_list

      })
    },
    methods:{
      NumberFormat(value){
        if (!value) {
          return '0'
        }
        const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') //将整数部分逢三一断
        return intPartFormat
      },
      price(data){
        if(data!=null){
          return (data/100).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,'$&,');
        }else{
          return 0;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }
</style>
